<template>
    <Layout>
        <PageHeader :items="items" :title="title"/>
        <loader :active="loading"/>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <i class="fa fa-people-arrows"></i> Social media
                    </div>
                    <div class="card-body">
                        <form class="needs-validation" @submit.prevent="saveSocialMedia">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="sm.facebook"><i class="fab fa-facebook-square"></i> Facebook</label>
                                        <input
                                            id="sm.facebook"
                                            v-model="sm.facebook"
                                            :class="{ 'is-invalid': $v.sm.facebook.$error }"
                                            class="form-control"
                                            placeholder="https://www.facebook.com/robotpl"
                                            type="url"
                                        />
                                        <div v-if="$v.sm.facebook.$error" class="invalid-feedback">
                                            <span v-if="!$v.sm.facebook.socialMedia">Podaj poprawny adres url: https://www.facebook.com/{info}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="sm.twitter"><i class="fab fa-twitter"></i> Twitter</label>
                                        <input
                                            id="sm.twitter"
                                            v-model="sm.twitter"
                                            :class="{ 'is-invalid': $v.sm.twitter.$error }"
                                            class="form-control"
                                            placeholder="https://twitter.com/robotpl"
                                            type="url"
                                        />
                                        <div v-if="$v.sm.twitter.$error" class="invalid-feedback">
                                            <span v-if="!$v.sm.twitter.socialMedia">Podaj poprawny adres url: https://twitter.com/{info}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="sm.youtube"><i class="fab fa-youtube"></i> Youtube</label>
                                        <input
                                            id="sm.youtube"
                                            v-model="sm.youtube"
                                            :class="{ 'is-invalid': $v.sm.youtube.$error }"
                                            class="form-control"
                                            placeholder="https://www.youtube.com/robotpl"
                                            type="url"
                                        />
                                        <div v-if="$v.sm.youtube.$error" class="invalid-feedback">
                                            <span v-if="!$v.sm.youtube.socialMedia">Podaj poprawny adres url: https://www.youtube.com/channel/{info} lub https://www.youtube.com/c/{info}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="sm.twitch"><i class="fab fa-twitch"></i> Twitch</label>
                                        <input
                                            id="sm.twitch"
                                            v-model="sm.twitch"
                                            :class="{ 'is-invalid': $v.sm.twitch.$error }"
                                            class="form-control"
                                            placeholder="https://www.twitch.tv/robotpl"
                                            type="url"
                                        />
                                        <div v-if="$v.sm.twitch.$error" class="invalid-feedback">
                                            <span v-if="!$v.sm.twitch.socialMedia">Podaj poprawny adres url: https://www.twitch.tv/{info}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="sm.instagram"><i class="fab fa-instagram"></i> Instagram</label>
                                        <input
                                            id="sm.instagram"
                                            v-model="sm.instagram"
                                            :class="{ 'is-invalid': $v.sm.instagram.$error }"
                                            class="form-control"
                                            placeholder="https://www.instagram.com/robotpl"
                                            type="url"
                                        />
                                        <div v-if="$v.sm.instagram.$error" class="invalid-feedback">
                                            <span v-if="!$v.sm.instagram.socialMedia">Podaj poprawny adres url: https://www.instagram.com/{info}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="sm.linkedin"><i class="fab fa-linkedin"></i> Linkedin</label>
                                        <input
                                            id="sm.linkedin"
                                            v-model="sm.linkedin"
                                            :class="{ 'is-invalid': $v.sm.linkedin.$error }"
                                            class="form-control"
                                            placeholder="https://www.linkedin.com/in/robotpl"
                                            type="url"
                                        />
                                        <div v-if="$v.sm.linkedin.$error" class="invalid-feedback">
                                            <span v-if="!$v.sm.linkedin.socialMedia">Podaj poprawny adres url: https://www.linkedin.com/in/{info}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="sm.github"><i class="fab fa-github"></i> Github</label>
                                        <input
                                            id="sm.github"
                                            v-model="sm.github"
                                            :class="{ 'is-invalid': $v.sm.github.$error }"
                                            class="form-control"
                                            placeholder="https://github.com/robotpl"
                                            type="url"
                                        />
                                        <div v-if="$v.sm.github.$error" class="invalid-feedback">
                                            <span v-if="!$v.sm.github.socialMedia">Podaj poprawny adres url: https://github.com/{info}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="sm.snapchat"><i class="fab fa-snapchat"></i> Snapchat</label>
                                        <input
                                            id="sm.snapchat"
                                            v-model="sm.snapchat"
                                            :class="{ 'is-invalid': $v.sm.snapchat.$error }"
                                            class="form-control"
                                            placeholder="RazorekMeister"
                                            type="text"
                                        />
                                        <div v-if="$v.sm.snapchat.$error" class="invalid-feedback">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="sm.telegram"><i class="fab fa-telegram"></i> Telegram</label>
                                        <input
                                            id="sm.telegram"
                                            v-model="sm.telegram"
                                            :class="{ 'is-invalid': $v.sm.telegram.$error }"
                                            class="form-control"
                                            placeholder="RazorMeister"
                                            type="text"
                                        />
                                        <div v-if="$v.sm.telegram.$error" class="invalid-feedback">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row d-flex justify-content-center">
                                <button class="btn btn-primary">
                                    <i class="fa fa-check"></i> Zapisz
                                </button>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>
import Layout from "../layouts/main";
import PageHeader from "@/components/page-header";
import SettingsService from "@/services/settings.service";
import {
    notificationMethods
} from "@/state/helpers";

import {helpers} from 'vuelidate/lib/validators'

const facebook = helpers.regex('alpha', /https:\/\/www.facebook.com\/(.*)/);
const youtube = helpers.regex('alpha', /(https:\/\/www.youtube.com\/channel\/(.*))|(https:\/\/www.youtube.com\/c\/(.*))/);
const twitter = helpers.regex('alpha', /https:\/\/twitter.com\/(.*)/);
const twitch = helpers.regex('alpha', /https:\/\/www.twitch.tv\/(.*)/);
const instagram = helpers.regex('alpha', /https:\/\/www.instagram.com\/(.*)/);
const linkedin = helpers.regex('alpha', /https:\/\/www.linkedin.com\/in\/(.*)/);
const github = helpers.regex('alpha', /https:\/\/github.com\/(.*)/);

/**
 * Starter component
 */
export default {
    name: "Groups",
    components: {Layout, PageHeader},
    data() {
        return {
            title: "Ustawienia",
            items: [
                {
                    text: "Twoje konto",
                    href: "/"
                },
                {
                    text: "Ustawienia",
                    active: true
                }
            ],
            loading: true,
            sm: {}
        };
    },
    validations: {
        sm: {
            facebook: {socialMedia: facebook},
            twitter: {socialMedia: twitter},
            youtube: {socialMedia: youtube},
            twitch: {socialMedia: twitch},
            instagram: {socialMedia: instagram},
            linkedin: {socialMedia: linkedin},
            github: {socialMedia: github},
            snapchat: {},
            telegram: {}
        }
    },
    mounted() {
        this.loadData();
    },
    methods: {
        ...notificationMethods,
        loadData() {
            SettingsService.getData().then(
                response => {
                    this.sm = response.data.socialMedia;
                    this.loading = false;
                },
                error => {
                    console.log(error);
                    this.loading = false;
                }
            )
        },
        saveSocialMedia() {
            this.$v.sm.$touch();

            if (this.$v.sm.$invalid) {
                return;
            } else {
                this.loading = true;

                SettingsService.saveSocialMedia(this.sm).then(
                    () => {
                        this.success("Social media zostały zapisane");
                        this.loadData();
                    },
                    error => {
                        console.log(error);
                        this.loading = false;
                    }
                )
            }
        }
    }
};
</script>